import styled from 'styled-components';
import { BLACK, NEUTRAL_100 } from "@styles/colors";
import { INTER } from '@styles/fonts';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${NEUTRAL_100};
  color: ${BLACK};
  font-family: ${INTER.regular};
  font-size: 13px;
`;

export const Label = styled.span``;

export const Value = styled.span``;
